import { CrossDomainImage } from "../CrossDomainImage/CrossDomainImage";
import { ZapCard } from "../ZapCard";
import styles from "./TemplatesHomepages.module.css";
import { Text } from "@zapier/design-system";
import { type TemplateShowcaseItem } from "src/types";
import { useTranslations } from "next-intl";

export const FeaturedSolutionsSection = ({
  featuredSolutions,
}: {
  featuredSolutions: TemplateShowcaseItem[];
}) => {
  const t = useTranslations("Sections");
  return (
    <section>
      <Text
        type="PageHeader"
        tag="h2"
        margin="0 0 16px 0"
        className={styles.sectionHeader}
        color="TextDefault"
      >
        {t("featuredSolutionTemplates")}
      </Text>
      <div className={styles.featuredSolutions}>
        {featuredSolutions.map(
          (solution: TemplateShowcaseItem) =>
            solution.template && (
              <ZapCard
                key={solution.template.slug}
                template={solution.template}
                size="responsive"
                href={`/templates/details/${solution.template.slug}`}
                tagLabel={solution.name}
                renderedImage={
                  <CrossDomainImage
                    src={
                      solution.template.previewImage?.url ??
                      "https://images.ctfassets.net/0sppvm4cmdq7/42L9dKclk2wI6gI1Lgas4K/020b75d5c6590d7b4ea21e78a3f6e690/GenericThumbnail.png"
                    }
                    alt={solution.template.previewImage?.alt ?? ""}
                    fill
                    sizes="(max-width: 768px) 100vw, 50vw"
                    style={{
                      objectFit: "cover",
                      objectPosition: "top left",
                    }}
                  />
                }
              />
            ),
        )}
      </div>
    </section>
  );
};
